module.exports = __webpack_public_path__ + "static/media/001-envelope.4d9e5a20.svg";